const simpleHash = (value = "") => {
    let hash = 0;

    if (!value) {
        return "";
    }

    for (let index = 0; index < value.length; index += 1) {
        hash = (hash << 5) - hash + value.charCodeAt(index);
        hash |= 0;
    }

    return Math.abs(hash).toString(16);
};

const getCanvasFingerprint = () => {
    try {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        if (!context) {
            return "";
        }

        canvas.width = 240;
        canvas.height = 60;
        context.textBaseline = "top";
        context.font = "16px Arial";
        context.fillStyle = "#f60";
        context.fillRect(10, 10, 120, 30);
        context.fillStyle = "#069";
        context.fillText("fflip-checkout-security", 12, 14);
        context.strokeStyle = "#00c853";
        context.beginPath();
        context.arc(180, 28, 18, 0, Math.PI * 2, true);
        context.stroke();

        return simpleHash(canvas.toDataURL());
    } catch (error) {
        return "";
    }
};

export const getCurrentUnixTimestamp = () => Math.floor(Date.now() / 1000);

export const collectDeviceFingerprint = () => {
    const nav = window.navigator || {};
    const screen = window.screen || {};
    let timezone = "";

    try {
        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    } catch (error) {
        timezone = "";
    }

    return {
        screen_resolution: `${screen.width || 0}x${screen.height || 0}x${window.devicePixelRatio || 1}`,
        timezone: timezone || `offset:${new Date().getTimezoneOffset()}`,
        language: nav.language || (Array.isArray(nav.languages) ? nav.languages[0] : "") || "",
        platform: nav.platform || "",
        user_agent: nav.userAgent || "",
        canvas: getCanvasFingerprint(),
    };
};
